/* eslint-disable react/display-name */
import { useI18next } from 'gatsby-plugin-react-i18next';
import { generateNewTranslatedUrl } from '../../utils/i18n/route-translations';
import { forwardRef } from 'react';

const LanguageSwitcher = forwardRef<HTMLSelectElement, LanguageSwitcherType>(({ className = '' }, ref) => {
  const { language, languages, changeLanguage } = useI18next();

  const changeLanguageHandler = (newLanguage: string) => {
    const currentUrl = window.location.pathname;
    const { url, pathMappingObject } = generateNewTranslatedUrl(currentUrl, language, newLanguage);

    if (!pathMappingObject) {
      changeLanguage(newLanguage);
      return;
    }

    changeLanguage(newLanguage, url.replace(`/${newLanguage}/`, '/'));
    return;
  }

  return (
    <select
      className={`select cursor-pointer lg:mr-6 py-2 px-4 font-roboto text-primary uppercase hidden md:block appearance-none bg-transparent w-20 border border-primary ${className}`}
      style={{
        background: `url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 8'%3E%3Cpath fill='%23A38D70' fill-rule='evenodd' d='M0 0l8 4.681L16 0l-.06.043L8 8.001 0 0z' clip-rule='evenodd'/%3E%3C/svg%3E") no-repeat`,
        backgroundSize: '1rem',
        backgroundPosition: 'calc(100% - 0.5rem) center',
      }}
      onChange={e => changeLanguageHandler(e.target.value)}
      value={language}
      ref={ref}
      aria-label='Select language'
    >
      {languages.map(lng => (
        <option key={lng} value={lng}>
          {lng}
        </option>
      ))}
    </select>
  )
})

export default LanguageSwitcher

export type LanguageSwitcherType = {
  className?: string,
}
